import { render } from "./CustomerWaitListView.vue?vue&type=template&id=77890ee6&scoped=true&ts=true&lang=pug"
import script from "./CustomerWaitListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerWaitListView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerWaitListView.vue?vue&type=style&index=0&id=77890ee6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77890ee6"]])

export default __exports__